<template>
  <router-link
    :to="{ name: detailRouteName, params: { 'id': data.ID }}"
    tag="div"
    style="cursor: pointer;"
  >
    <div class="publication-preview shadow-hover">
      <div
        class="img"
        :style="{ backgroundImage: `url(${data.PREVIEW_PICTURE_PATH})`}"
      >
        <img
          :src="data.PREVIEW_PICTURE_PATH"
          style="visibility: hidden; width: 100%;"
        >
      </div>
      <div class="body">
        <p v-if="date">
          {{ data.DATE_CREATE | moment('DD.MM.YYYY') }}
        </p>
        <p
          class="title"
          v-html="data.NAME"
        />
        <p
          v-if="descriptionNotEmpty"
          class="description"
          v-text="description"
        />
        <router-link
          class="text-danger"
          :to="{ name: detailRouteName, params: { 'id': data.ID }}"
          v-text="moreText"
        />
      </div>
    </div>
  </router-link>
</template>

<script>
import { decodeHtml } from '../helper'

export default {
  name: 'PublicationPreview',
  props: {
    data: {
      type: Object,
      required: true
    },
    date: {
      type: Boolean,
      default: true
    },
    descriptionLimit: {
      type: Number,
      default: 0
    },
    detailRouteName: {
      type: String,
      required: true
    },
    moreText: {
      type: String,
      default: 'Подробнее'
    }
  },
  computed: {
    description () {
      return this.descriptionLimit && this.data.PREVIEW_TEXT.length > this.descriptionLimit
        ? this.data.PREVIEW_TEXT.substr(0, this.descriptionLimit - 3) + '...'
        : this.data.PREVIEW_TEXT
    },
    descriptionNotEmpty () {
      return /\S/.test(decodeHtml(this.description))
    }
  }
}
</script>

<style scoped>
.publication-preview {
  height: 100%;
  background-color: white;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.publication-preview,
.publication-preview .img {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.publication-preview .img {
  width: 100%;
  background-size:     cover;
  background-position: center;
  background-repeat: no-repeat;
}

.publication-preview .body {
  padding: 30px;
}

.publication-preview .body .title {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
